import { render } from "./QuickpaySettingsPaymentPartnersLoader.vue?vue&type=template&id=5539f672&scoped=true"
const script = {}

import "./QuickpaySettingsPaymentPartnersLoader.vue?vue&type=style&index=0&id=5539f672&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5539f672"]])

export default __exports__